import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { VIEWPORTS } from '../constants/viewports.constant';
import { WINDOW } from './window.service';

@Injectable({
  providedIn: 'root'
})
export class ViewportService {
  private isDesktopSubject: BehaviorSubject<boolean>;
  public isDesktopObservable: Observable<boolean>;

  constructor(@Inject(WINDOW) private window: Window) {
    this.isDesktopSubject = new BehaviorSubject(this.getIsDesktop());
    this.isDesktopObservable = this.isDesktopSubject.asObservable();

    this.window.addEventListener('resize', this.onResize.bind(this));
    this.window.addEventListener('beforeprint', this.onBeforePrint.bind(this));
    this.window.addEventListener('afterprint', this.onResize.bind(this));
  }

  private getIsDesktop() {

    return this.window.innerWidth >= VIEWPORTS.mediumLarge;
  }

  private onResize() {
    this.isDesktopSubject.next(this.getIsDesktop());
  }

  private onBeforePrint() {
    // Forçar que o leiaute enviado para a impressão seja o Desktop
    this.isDesktopSubject.next(true);
  }

  public scrollToTop() {
    const isDesktop = this.getIsDesktop();

    const screenHeight = isDesktop ? 200 : 134;

    setTimeout(() => {
      window.scroll(0, screenHeight);
    }, 0);
  }
}
